export const TOKEN_NOT_PROVIDED = 'token_not_provided'
export const TOKEN_INVALID = 'token_invalid'
